import { scrollToElement } from "../../../js/utils/helper/helper";
import Lightbox from "../../elements/lightbox/lightbox";

class DoubleOptInLightbox extends Lightbox {
  /**
   * extended lightbox that shows double opt-in status based on url params
   *
   * @param {HTMLElement} element - double opt-in lightbox
   */
  constructor(element) {
    super(element);

    this.dataAttributes = {
      successTitle: "data-success-title",
      successCopy: "data-success-copy",
      errorTitle: "data-error-title",
      errorCopy: "data-error-copy",
    };

    this.lightboxTitle = this.element.querySelector(".js-Lightbox-title");
    this.lightboxCopy = this.element.querySelector(".js-Lightbox-copy");
    this.lightboxLink = this.element.querySelector(".js-Lightbox-link");
    this.donationForm = document.querySelector(".js-PaymentForm");

    this._onLinkClick = this._onLinkClick.bind(this);

    this._checkUrlParams(document.location);
  }

  /**
   * checks and opens lightbox if relevant double opt-in params are available in the url e.g.
   * http://greenpeace-website.test/spenden?signature-verified=y&submission=success
   * http://greenpeace-website.test/spenden?signature-verified=y&submission=invalid
   *
   * sets title and copy of lightbox according to doi status
   *
   * @param {string} location - url to current location
   */
  _checkUrlParams(location) {
    const url = new URL(location);
    const verified = url.searchParams.get("signature-verified");
    const submission = url.searchParams.get("submission");

    if (verified === "y" && submission) {
      const isSuccess = submission === "success";

      this.lightboxTitle.innerHTML = this.element.getAttribute(
        this.dataAttributes[isSuccess ? "successTitle" : "errorTitle"]
      );

      this.lightboxCopy.innerHTML = this.element.getAttribute(
        this.dataAttributes[isSuccess ? "successCopy" : "errorCopy"]
      );

      if (this.lightboxLink) {
        this.lightboxLink.addEventListener("click", this._onLinkClick);
      }

      this.openLightbox();
    }
  }

  /**
   * handles click on lightbox link
   * scrolls to donation form if available
   *
   * @param {object} event
   */
  _onLinkClick(event) {
    event.preventDefault();

    if (this.donationForm) {
      scrollToElement(this.donationForm);
    }

    this._closeLightbox();
  }
}

export default DoubleOptInLightbox;
